<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('/img/profile.jpg')"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">Profile</h1>
        </div>
      </div>
    </div>

    <div class="section profile-content">
      <div class="container">
        <div class="content-stack">
          <section class="content-card">
            <div class="card-body">
              <div class="profile-carousel-wrap">
                <el-carousel
                  :autoplay="false"
                  indicator-position="outside"
                  height="428px"
                >
                  <el-carousel-item
                    v-for="image in profileImages"
                    :key="image.src"
                  >
                    <div class="profile-slide">
                      <img
                        :src="image.src"
                        :alt="image.alt"
                        class="profile-carousel-image"
                      />
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="profile-summary-copy">
                <!-- <span class="profile-badge"></span> -->
                <h2 class="profile-name">SPAREONE's Profile</h2>
                <p class="profile-role"></p>
              </div>
              <p class="profile-intro profile-summary-intro">
                이것저것 다 해보고 싶은 사람의 이것저것 했던 기록을 남깁니다.
              </p>
            </div>
          </section>

          <section class="content-card">
            <div class="section-heading">
              <span>About</span>
              <h3>준비중</h3>
            </div>
            <p>
              자기소개 준비중입니다.
            </p>
          </section>

          <section class="content-card">
            <div class="section-heading">
              <span>SKILLS</span>
              <h3>보유 스킬</h3>
            </div>
            <div class="chip-grid">
              <span
                v-for="skill in skills"
                :key="skill"
                class="skill-chip"
              >
                {{ skill }}
              </span>
            </div>
          </section>

          <section class="content-card">
            <div class="section-heading">
              <span>Timeline</span>
              <h3>활동 내역</h3>
            </div>
            <div
              v-for="item in timeline"
              :key="item.title"
              class="timeline-item"
            >
              <div class="timeline-marker"></div>
              <div class="timeline-copy">
                <div class="timeline-meta">{{ item.period }}</div>
                <h4>{{ item.title }}</h4>
                <p>{{ item.description }}</p>
              </div>
            </div>
          </section>

          <section class="content-card accent-card">
            <div class="section-heading">
              <span>Contact</span>
              <h3>문의하기</h3>
            </div>
            <p>
              준비중입니다.
            </p>
            <div class="contact-actions">
              <a
                href="#"
                class="btn btn-info btn-round"
              >
                문의하기
              </a>
              <a
                href="/"
                class="btn btn-neutral btn-round"
              >
                Go Home
              </a>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, CarouselItem } from 'element-ui';

export default {
  name: 'profile-page',
  bodyClass: 'landing-page',
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  data() {
    return {
      profileImages: [
        {
          src: '/img/profile.jpg',
          alt: 'Profile 01'
        },
        {
          src: '/img/profile2.jpeg',
          alt: 'Profile 02'
        },
      ],
      skills: [
        'C/C++',
        'Python',
        'JAVA',
        'Spring',
        'PHP',
        'SQL',
        'Vue',
        'React',
        'AWS',
        'Docker',
        'Burp Suite',
        'WireShark',
        'Premier Pro',
        'Lightroom',
        'Logic Pro',
        'Drums',
        'Guitar',
        'Bass',
      ],
      timeline: [
        {
          period: '2024. 07. - NOW',
          title: '포항 기쁨의교회 Stella Cantabile(작사작곡 팀) 드럼, 영상 담당',
        },
        {
          period: '2020. 02. - NOW',
          title: '포항 기쁨의교회 청년하람 Revive(미디어팀) 영상 담당',
        },
        {
          period: '2019. 03. - NOW',
          title: '포항 기쁨의교회 청년하람 Rebuild(찬양팀) 드럼 반주, 밴드마스터',
        },
        {
          period: '2018. 11. - NOW',
          title: '포항 기쁨의교회 Joyance(찬양팀) 드럼 반주',
        },
        {
          period: '2026. 04',
          title: 'SK Shieldus Rookies 28기 최종프로젝트 대상',
        },
        {
          period: '2025. 10. - 2026. 04',
          title: 'SK Shieldus Rookies 28기 수료 (최종프로젝트 트랙: 모의해킹)',
        },
        {
          period: '2026. 02.',
          title: '국립부경대학교 졸업',
        },
        {
          period: '2025. 12.',
          title: '2025 컴퓨터·인공지능공학부 DevDay 캡스톤디자인 경진대회 은상',
          // description:
          //   '2025. 12. 03. / 국립부경대학교 / 2025 컴퓨터·인공지능공학부 DevDay 캡스톤디자인 경진대회 은상'
        },
        {
          period: '2025. 10.',
          title: '한동대 메이저리그 캠프 쵤영 STAFF (3일)',
        },
        {
          period: '2025. 10.',
          title: '2025 KUCIS 정보보호 직무 멘토링 프로그램 참여 (현대자동차 정보보안실)',
        },
        {
          period: '2025. 08.',
          title: 'PCCP Lv. 2',
        },
        {
          period: '2025. 08.',
          title: '2025 정보보호 온라인 실습교육 수료',
        },
        {
          period: '2025. 05.',
          title: '2025학년도 1학기 프로그래밍 경진대회 장려상',
          // description:
          //   '2025. 05. 03. / 국립부경대학교 / 2025학년도 1학기 프로그래밍 경진대회 장려상'
        },
        {
          period: '2024. 08.',
          title: '2024 정보보호 온라인 실습교육 수료',
          // description:
          //   '2024. 08. / KUCIS / 대한민국'
        },
        {
          period: '2024. 06.',
          title: '제2회 전라남도 웹취약점 경진대회 장려상',
          // description:
          //   '2024. 06. 27. / 한국융합보안학회 / 제2회 전라남도 웹취약점 경진대회 장려상'
        },
        {
          period: '2023. 10.',
          title: 'SQLD 자격증 취득',
          // description:
          //   '2023. 10. ??. / KDATA / 대한민국'
        },
        {
          period: '2023. 08.',
          title: '대학생 교육기부 프로그램 쏙쏙캠프 교육봉사 (화복중학교)',
        },
        {
          period: '2023. 07.',
          title: '2023 정보보호 온라인 실습교육 수료',
          // description:
          //   '2023. 07. / KUCIS / 대한민국'
        },
        {
          period: '2023. 07.',
          title: '2023 대경권 대학생 프로그래밍 경진대회 대상',
          // description:
          //   '2023. 07. 03. / 대구가톨릭대학교 / 2023 대경권 대학생 프로그래밍 경진대회 대상'
        },
        {
          period: '2021. 02. - 2022. 11.',
          title: '대한민국 공군 정보보호병 복무',
        },
        {
          period: '2020. 10.',
          title: '제2회 DCU 소프트웨어 대전 - 소프트웨어 코딩 경진대회 우수상',
          // description:
          //   '2020. 10. 15. / 대구가톨릭대학교 / 제2회 DCU 소프트웨어 대전 - 소프트웨어 코딩 경진대회 우수상'
        },
        {
          period: '2020. 05.',
          title: '2020 대경권 대학생 프로그래밍 경진대회 최우수상',
          // description:
          //   '2020. 5. 30. / 대구가톨릭대학교 / 2020 대경권 대학생 프로그래밍 경진대회 최우수상'
        },
        {
          period: '2017. 05.',
          title: '프로그래밍기능사(구: 정보처리기능사) 자격증 취득',
          // description:
          //   '2017. 05. ??. / HRDK / 대한민국'
        },
      ],
    };
  }
};
</script>

<style scoped>
.profile-content-page {
  background: linear-gradient(180deg, #f4efe8 0%, #f8f5f0 40%, #ffffff 100%);
}

.profile-content {
  padding: 70px 0;
  position: relative;
  z-index: 3;
}

.profile-summary,
.content-card {
  border: 0;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 24px 60px rgba(60, 41, 19, 0.12);
}

.profile-summary {
  border-radius: 0;
}

.profile-summary .card-body,
.content-card {
  padding: 32px;
}

.profile-carousel-wrap {
  max-width: 760px;
  margin: 0 auto;
  overflow: hidden;
}

.profile-slide {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.profile-carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.profile-badge {
  display: inline-block;
  margin-bottom: 12px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #1f1f1f;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.profile-summary-copy {
  margin-top: 18px;
  text-align: center;
}

.profile-name {
  margin-bottom: 8px;
  text-align: center;
}

.profile-role {
  margin-bottom: 16px;
  color: #2ca8ff;
  font-weight: 600;
  text-align: center;
}

.profile-intro {
  max-width: 560px;
  margin-bottom: 0;
  color: #5e5a55;
  line-height: 1.8;
  text-align: center;
}

.profile-summary-intro {
  margin: 8px auto 0;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  flex: 1;
}

.stat-card {
  padding: 16px 12px;
  border-radius: 18px;
  background: #f6f1ea;
  text-align: center;
}

.stat-card strong {
  display: block;
  color: #1f1f1f;
  font-size: 1.25rem;
}

.stat-card span {
  display: block;
  margin-top: 6px;
  color: #7b746c;
  font-size: 0.8rem;
}

.link-list {
  display: grid;
  gap: 12px;
  width: 230px;
  flex-shrink: 0;
}

.profile-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-radius: 16px;
  background: #fff;
  color: #2b2b2b;
  box-shadow: inset 0 0 0 1px rgba(31, 31, 31, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.profile-link:hover {
  color: #2b2b2b;
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: inset 0 0 0 1px rgba(31, 31, 31, 0.08),
    0 14px 30px rgba(31, 31, 31, 0.08);
}

.content-stack {
  display: grid;
  gap: 24px;
}

.section-heading {
  margin-bottom: 18px;
}

.section-heading span {
  display: inline-block;
  margin-bottom: 8px;
  color: #2ca8ff;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.section-heading h3 {
  margin-bottom: 0;
}

.content-card p:last-child {
  margin-bottom: 0;
}

.chip-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.skill-chip {
  padding: 10px 14px;
  border-radius: 999px;
  background: #f5ede4;
  color: #4d4338;
  font-weight: 600;
}

.timeline-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 14px 0;
}

.timeline-item + .timeline-item {
  border-top: 1px solid rgba(92, 77, 59, 0.12);
}

.timeline-marker {
  width: 12px;
  height: 12px;
  margin-top: 0;
  transform: translateY(5px);
  border-radius: 50%;
  flex-shrink: 0;
  background: linear-gradient(135deg, #2ca8ff, #1b7fe0);
  box-shadow: 0 0 0 6px rgba(44, 168, 255, 0.14);
}

.timeline-meta {
  margin-top: 3px;
  margin-bottom: 6px;
  color: #2ca8ff;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.timeline-copy h4 {
  margin-bottom: 6px;
  margin-top: 0;
}

.timeline-copy p {
  margin-bottom: 0;
}

.accent-card {
  background: linear-gradient(135deg, #0b5ed7 0%, #169bff 52%, #64d2ff 100%);
  color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 28px 60px rgba(22, 116, 214, 0.28);
}

.accent-card .section-heading span,
.accent-card p {
  color: #ffffff;
}

.accent-card h3 {
  color: #fff;
}

.contact-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 22px;
}

.accent-card .btn {
  min-width: 170px;
  margin: 0;
  border: 0;
  box-shadow: none;
}

.accent-card .btn-info {
  background: #ffffff;
  color: #0d63d6;
}

.accent-card .btn-info:hover,
.accent-card .btn-info:focus {
  background: #eef7ff;
  color: #0a58ca;
}

.accent-card .btn-neutral {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28);
}

.accent-card .btn-neutral:hover,
.accent-card .btn-neutral:focus {
  background: rgba(255, 255, 255, 0.26);
  color: #ffffff;
}

@media (max-width: 991px) {
  .profile-slide {
    padding: 0;
  }
}

@media (max-width: 767px) {
  .stat-grid {
    grid-template-columns: 1fr;
  }

  .profile-summary .card-body,
  .content-card {
    padding: 24px;
  }
}
</style>
